import TemplateView from "../../TemplateView";
import {TaskManagementViewMode} from "../constants"
import {bindActionCreators} from 'redux'
import {getViewMode} from '../common/selectors'
import {switchViewMode} from '../common/actions'
import {connect} from '../../redux/utils'

export default class ViewModeSelector extends TemplateView {
    constructor({
        onModeSelected = mode => {}
    }) {
        super()

        this.onModeSelected = onModeSelected

        this.state = {
            viewMode: null
        }

        this.onStatePropertyChanged('viewMode', viewMode => this._updateViewMode(viewMode))
    }

    templateHtml() {
        return "<div class='viewModeSelector'>" +
               "  <div class='label'><%=viewMode%></div>" +
               "  <div class='modeButton table'></div>" +
               "  <div class='modeButton kanban'></div>" +
               "</div>"
    }

    afterRender() {
        this.$tableButton = this.find(".modeButton.table").click(() => this.onModeSelected(TaskManagementViewMode.TABLE))
        this.$kanbanButton = this.find(".modeButton.kanban").click(() => this.onModeSelected(TaskManagementViewMode.KANBAN))
    }

    messageKeys() {
        return {
            viewMode: 'task.list.view_mode'
        }
    }

    _updateViewMode(viewMode) {
        this.$tableButton.toggleClass('active', viewMode === TaskManagementViewMode.TABLE)
        this.$kanbanButton.toggleClass('active', viewMode === TaskManagementViewMode.KANBAN)
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/header/ViewModeSelector.js